function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var presetImagePixelSizesByName = {
  micro: 56,
  mini: 90,
  thumb: 130,
  medium: 165,
  category_listing: 229,
  preview: 300,
  normal: 350,
  original: 1024
};
var sizes = ['thumb', 'preview', 'original', 'normal', 'mini', 'micro', 'medium', 'category_listing'];
export var getProductImageURL = function getProductImageURL(url) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'preview';
  var newUrl = url.replace('{size}', size);
  var hasExistingSize = sizes.some(function (imageSize) {
    return url.includes("/".concat(imageSize, "_"));
  });
  if (newUrl === url && !hasExistingSize) {
    console.warn("image URL \"".concat(url, "\" does not contain \"{size}\" token"));
  }
  return newUrl.replace(/%25/g, '%'); // Handle double encoding of special characters. Remove once root cause is fixed
};
var getPresetImageUrlAndDimensions = function getPresetImageUrlAndDimensions(originalURL, namedSize) {
  return {
    src: getProductImageURL(originalURL, namedSize),
    width: presetImagePixelSizesByName[namedSize],
    height: presetImagePixelSizesByName[namedSize]
  };
};
export var getProductImageSizes = function getProductImageSizes(originalURL, namedSizes) {
  return namedSizes.reduce(function (sizes, namedSize) {
    return _objectSpread(_objectSpread({}, sizes), {}, {
      [namedSize]: getPresetImageUrlAndDimensions(originalURL, namedSize)
    });
  }, {});
};
export var getProductResponsiveImagesForSizes = function getProductResponsiveImagesForSizes(originalURL, namedSizes) {
  return namedSizes.map(function (namedSize) {
    return getPresetImageUrlAndDimensions(originalURL, namedSize);
  });
};